
const $appStatePlugin = {
    install: (app) => {
        app.config.globalProperties.$appState = reactive({
            primary: 'emerald',
            surface: 'zinc',
            darkTheme: false,
            codeSandbox: false,
            sourceType: 'options-api',
            newsActive: false,
            announcement: null,
            storageKey: 'primevue-tailwind'
        });
    }
};

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use($appStatePlugin);
});
